import React from 'react';
import Rive from '@rive-app/react-canvas';

interface ISlRiveAnimationProps {
	path: string;
	ratio: string;
}

enum RiveRatio {
	SizeA = '16:9',
	SizeB = '4:3',
}

const riveRatioMap = {
	[RiveRatio.SizeA]: '16/9',
	[RiveRatio.SizeB]: '4/3',
};

export function SlRiveAnimation({ path, ratio }: ISlRiveAnimationProps) {
	const style = { width: '100%', height: 'auto', aspectRatio: riveRatioMap[ratio] };

	return path ? <Rive src={path} stateMachines="SM" style={style} /> : null;
}
